import { render, staticRenderFns } from "./BvaUsers.vue?vue&type=template&id=cfa14760&"
import script from "./BvaUsers.vue?vue&type=script&lang=ts&"
export * from "./BvaUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports